import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import {MainLayout, InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import emailjs from 'emailjs-com';
import { GiSmartphone } from 'react-icons/gi'
import { BsPinMap } from 'react-icons/bs'
import { MdAlternateEmail } from 'react-icons/md'
import { init } from 'ityped';

const Result = () => {
    return(
        <Paragraph>Thanks, i'll reply your message ASAP! 😉</Paragraph>
    )  
}

function ContactPage() {

    const textRef = useRef();
    useEffect(()=>{
        init(textRef.current, {
            showCursor: false,
            strings: ["lets get in touch.", "or you can say hi.", "don't hesitate 😉.", "let's make something special."],
            typeSpeed: 150,
            backSpeed: 80,
            startDelay: 2000,
            backDelay: 4500,
        })
    },[])

    const [result, showResult] = useState(false);
    const form = useRef();
    const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_nikg22i', 'template_v2q3rdl', form.current, 'user_V3Ps76KsVlp3xKClhD0sv')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset();
        showResult(true);
    }; 
    setTimeout (() => {
        showResult(false)
    },20000);

    return (
        <>
        <title>Contact | Foxicode</title>
        <MainLayout>
            <Title title={'Contact'} span={'接触'} />
            <ContactPageStyled >
            <InnerLayout className={'contact-section'}>
                <div className="left-content">
                    <div className="contact-title">
                        <h4>Get In Touch</h4>
                        <TitleDesc>Hey there! <span ref={textRef}></span></TitleDesc>
                    </div>
                    <form  className="form" onSubmit={sendEmail} ref={form}>
                        <div className="form-field">
                            <label htmlFor="name" >Your Name*</label>
                            <input type="text" id="name" name="name" placeholder="Enter your name" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="email" >Email*</label>
                            <input type="email" id="email" placeholder="example@google.com" name="email" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="subject" >Subject</label>
                            <input type="text" id="subject" name="subject" placeholder="Enter your subject" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="text-area">Message*</label>
                            <textarea id="textarea" cols="30" rows="10" name="message" placeholder="Enter your message.." ></textarea>
                        </div>
                        <div className="form-field f-button">
                            <PrimaryButtonStyled type="submit" value="Send" />
                        </div>
                            <PopUp>{result ? <Result /> : null}</PopUp>
                    </form>
                </div>
                <div className="right-content">
                    <TopContent>
                        <TopList>
                            <TopTitle>Contact Info</TopTitle>
                            <a href="tel:+6285156456453"><Phone/>+62-85156456453</a>
                            <a href="mailto:dwiandika911@gmail.com"><Email/>dwiandika911@gmail.com</a>
                            <Top><Map/>Tangerang, Indonesia</Top>
                        </TopList>
                    </TopContent>
                    <BottomDiv>
                    <BottomContent>
                    <MapList src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31729.433836538643!2d106.68734936478643!3d-6.240093760911785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69fa14971f8dfb%3A0x16790a55b650b013!2sCiledug%2C%20Tangerang%20City%2C%20Banten!5e0!3m2!1sen!2sid!4v1639407394652!5m2!1sen!2sid" allowfullscreen="" loading="lazy"></MapList>
                    </BottomContent>
                    </BottomDiv>
                </div>
            </InnerLayout>
            </ContactPageStyled>
        </MainLayout>
        </>
    )
}

const TitleDesc = styled.p`
    @media screen and (max-width: 480px){
        margin-left: 1rem;
    }
    
`
const BottomDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    
`
const TopContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`
const TopTitle = styled.p`
    color: #c46500;
    font-size: 2rem;
    text-align: left;
    margin-bottom: 10px;
    font-weight: bold;
    @media screen and (max-width: 480px){
        font-size: 1.5rem;
        padding: 0;
        margin-top: -0.7rem;
    }
`
const TopList = styled.div`
    justify-content: center;
    align-items: center;
    display: grid;
    padding: 2rem 2rem;
    background: transparent;
    border: 2px solid #c46500;
    margin-top: 6.8rem;
    @media screen and (max-width: 480px){
        width: auto;
        padding: 2rem 2rem;
        height: 30vh;
        margin-bottom: 1rem;
        margin-top: 0;
    }
    a{
    text-align: left;
    width: 100%;
    font-size: 1.7rem;
    margin-bottom: 0.5rem;
    @media screen and (max-width: 480px){
        font-size: 1rem;
    }
    }
`
const Top = styled.div`
    text-align: left;
    width: 100%;
    font-size: 1.7rem;
    margin-bottom: 0.5rem;
    font-size: 100;
    @media screen and (max-width: 480px){
        font-size: 1rem;
    }

`
const BottomContent = styled.div`
    justify-content: center;
    align-items: center;
    display: grid;
    padding: 3.3rem 3.3rem;
    background: transparent;
    border: 2px solid #c46500;

    @media screen and (max-width: 768px){
        margin-top: 2rem;
    }
    @media screen and (max-width: 480px){
        width: 90%;
        margin-top: 2rem;
        padding: 1rem 1rem;
        height: 30vh;
        margin-bottom: 1rem;
        margin-top: 0;
    }
`
const MapList = styled.iframe`
    width: 100%;
    height: 100%;
`

const Map = styled(BsPinMap)`
    font-size: 1.7rem;
    margin-right: 15px;
    color: #c46500;
    @media screen and (max-width: 480px){
        font-size: 1.4rem;
    }
`
const Phone = styled(GiSmartphone)`
    font-size: 1.7rem;
    margin-right: 15px;
    color: #c46500;
    @media screen and (max-width: 480px){
        font-size: 1.4rem;
    }
`
const Email = styled(MdAlternateEmail)`
    font-size: 1.7rem;
    margin-right: 15px;
    color: #c46500;
    @media screen and (max-width: 480px){
        font-size: 1.4rem;
    }
`

const Paragraph = styled.p`
        font-size: 20px;
        display: flex;
        color: var(--border-color);
        text-align: center;

        @media screen and (max-width: 480px){
            font-size: 15px;
        }
`
const PopUp = styled.div`
        display: flex;
        margin-top: 1rem;
        align-items: center;
        justify-content: center;
`

const PrimaryButtonStyled = styled.input`
    background-color: transparent;
    padding: .8rem 2.5rem;
    color: #c46500;
    cursor: pointer;
    display: inline-block;
    font-size: inherit;
    text-transform: uppercase;
    position: relative;
    transition: all .4s ease-in-out;
    border-radius: 2px;
    border: 1px solid #c46500;
    &::after{
        content: "";
        position: absolute;
        width: 0;
        height: .2rem;
        transition: all .4s ease-in-out;
        left: 0;
        bottom: 0;
        opacity: .7;
    }
    &:hover::after{
        width: 100%;
        background-color: #c46500;
    }
`;

const ContactPageStyled = styled.section`
    .popUp{
        font-size: 35px;
        display: flex;
        color: #c46500;
        margin-top: 1rem;
        text-align: center;
    }
    .contact-section{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 2rem;
        @media screen and (max-width: 978px){
            grid-template-columns: repeat(1, 1fr);
            .f-button{
                margin-bottom: 3rem;
            }
        }
        .right-content{
            display: grid;
            grid-template-columns: repeat(1, 1fr);
        }
        .contact-title{
            h4{
                color: var(--white-color);
                padding: 1rem 0;
                font-size: 1.8rem;
                @media screen and (max-width: 480px){
                    padding: 1rem 1rem;
                }
            }
        }
        .form{
            width: 100%;
            @media screen and (max-width: 768px){
                align-items: center;
                justify-content: center;
                padding: 1rem 1rem;
            }
            @media screen and (max-width: 480px){
                align-items: center;
                justify-content: center;
                padding: 1rem 1rem;
                margin: 0;
            }
            .form-field{
                margin-top: 2rem;
                position: relative;
                width: 100%;
                label{
                    position: absolute;
                    left: 20px;
                    top: -19px;
                    display: inline-block;
                    background-color: var(--background-dark-color);
                    padding:0 .5rem;
                    color: inherit;
                }
                input{
                    border: 2px solid #c46500;
                    outline: none;
                    background: transparent;
                    height: 50px;
                    padding:0 15px;
                    width: 100%;
                    color: inherit;
                    @media screen and (max-width: 480px){
                        width: 100%;
                    }
                }
                textarea{
                    background-color: transparent;
                    border: 2px solid #c46500;
                    outline: none;
                    color: inherit;
                    width: 100%;
                    padding: .8rem 1rem;
                }
            }

            
        }
    }
`;

export default ContactPage
